import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e37865ce")
const _hoisted_1 = {
  key: 0,
  class: "padding"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "padding"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dig-ui-icon", {
  type: "add",
  class: "add-button"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "invoice" }
const _hoisted_7 = { class: "control-icons" }
const _hoisted_8 = ["onClick", "title"]
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = ["onClick", "title"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("dig-ui-loader", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.invoices.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('noInvoice')), 1))
            : _createCommentVNode("", true),
          (_ctx.isSuperadmin)
            ? (_openBlock(), _createElementBlock("dig-input-file", {
                key: 1,
                onLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addInvoice($event))),
                accept: ".pdf"
              }, _hoisted_5, 32))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
            return (_openBlock(), _createElementBlock("div", {
              key: invoice.name
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("dig-ui-icon", {
                    type: "download",
                    class: "icon-button",
                    onClick: ($event: any) => (_ctx.downloadInvoice(invoice)),
                    title: _ctx.$t('download')
                  }, null, 8, _hoisted_8),
                  _createElementVNode("dig-ui-icon", {
                    type: "delete",
                    class: "icon-button",
                    onClick: ($event: any) => (_ctx.deleteInvoice(invoice)),
                    title: _ctx.$t('delete')
                  }, null, 8, _hoisted_9),
                  _createElementVNode("dig-ui-icon", {
                    type: "show",
                    class: "icon-button",
                    onClick: ($event: any) => (_ctx.goToInvoice(invoice.name)),
                    title: _ctx.$t('show')
                  }, null, 8, _hoisted_10)
                ]),
                _createTextVNode(" " + _toDisplayString(invoice.name), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}